import * as React from "react";

import classNames from "classnames";
import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { TITLE_MAX_LENGTH } from "../../../pages/keyword-analysis/KeywordGroupEditorHelpers";

const Header = styled(CenteredFlexRow)`
    justify-content: space-between;
`;

const HeaderForm = styled.form`
    flex: 1;
    margin: 0 16px 0 0;
`;

export class ListTitle extends React.Component<any, any> {
    private _input: HTMLInputElement;
    constructor(props) {
        super(props);
        this.onInputMouseEnter = this.onInputMouseEnter.bind(this);
        this.onInputFocus = this.onInputFocus.bind(this);
        this.onInputBlur = this.onInputBlur.bind(this);
        this.onInputMouseLeave = this.onInputMouseLeave.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            inputMouseEnter: false,
            inputFocus: true,
        };
    }

    componentDidMount() {
        if (this.props.preventFocusOnMount !== true) {
            setTimeout(() => {
                this._input.focus();
            }, 200);
        }
    }

    onInputMouseEnter() {
        this.setState({
            inputMouseEnter: true,
        });
    }

    onInputMouseLeave() {
        this.setState({
            inputMouseEnter: false,
        });
    }

    onInputFocus() {
        this.props.onListTitleFocus?.();
        this.setState({
            inputFocus: true,
        });
    }

    onInputBlur() {
        this.setState({
            inputFocus: false,
        });
    }

    onSubmit(e) {
        e.preventDefault();
        this.onTitleChanged(this._input.value);
    }

    onTitleChanged(newTitle) {
        this.props.onListTitleChange?.(newTitle);
    }

    onInputChange = (e) => {
        this.onTitleChanged(e.target.value);
        this.props.onListTitleInput?.(e);
    };

    trackError(errorMessage) {
        this.props.tracker.onError(errorMessage);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.title !== this.props.title) {
            const { errorMessage, isValid } = this.props.title;
            const showError = !isValid && errorMessage && !this.state.inputFocus;
            if (showError) {
                this.trackError(errorMessage);
            }
        }
    }

    render() {
        const { placeHolderText, inputMaxLength, title } = this.props;
        const showPencilIcon = this.state.inputMouseEnter && !this.state.inputFocus;
        const { isValid, errorMessage, text } = title;
        const validText = text?.slice(0, inputMaxLength) ?? "";
        const showError = !isValid && !this.state.inputFocus;
        return (
            <Header className={classNames("items-list-title", { "invalid-title": !isValid })}>
                <HeaderForm onSubmit={this.onSubmit}>
                    <div
                        onMouseLeave={this.onInputMouseLeave}
                        onMouseEnter={this.onInputMouseEnter}
                        className={classNames("customCategoriesWizard-name", {
                            "customCategoriesWizard-name-focused": !showPencilIcon,
                        })}
                    >
                        <div className="customCategoriesWizard-name-input">
                            <input
                                ref={(input) => {
                                    this._input = input;
                                }}
                                onFocus={this.onInputFocus}
                                onBlur={this.onInputBlur}
                                onChange={this.onInputChange}
                                tabIndex={1}
                                maxLength={inputMaxLength}
                                type="text"
                                placeholder={placeHolderText}
                                value={validText}
                                data-automation="list-title-name"
                            />
                            <div className="customCategoriesWizard-name-input-bar"></div>
                        </div>
                        {showError ? (
                            <i
                                data-scss-tooltip={errorMessage}
                                className="customCategoriesWizard-invalid-icon customCategoriesWizard-editor-invalid-format iconInfo iconInfo--white u-alignRight scss-tooltip scss-tooltip--w"
                            >
                                !
                            </i>
                        ) : null}
                        {showPencilIcon && !showError ? (
                            <i className="customCategoriesWizard-icon sw-icon-edit" />
                        ) : null}
                    </div>
                </HeaderForm>
                {this.props.showGoToMonitorKeywordListButton ? (
                    <IconButton
                        iconName="arrow-right"
                        type="outlined"
                        onClick={this.props.onGoToMonitorKeywordList}
                    >
                        {translate("keyword.query.bar.edit.modal.view.keyword.in.list.button.text")}
                    </IconButton>
                ) : null}
            </Header>
        );
    }

    static defaultProps = {
        inputMaxLength: TITLE_MAX_LENGTH,
        preventFocusOnMount: false,
        showGoToMonitorKeywordListButton: false,
    };
}
